import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Plus, Pencil, Trash2 } from "lucide-react";

const empty = { number: "", owner_name: "", owner_phone: "", capacity: "" };

export default function Trucks() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);
  const [editId, setEditId] = useState(null);

  const load = () => api.get("/trucks").then(({data})=>setItems(data));
  useEffect(()=>{ load(); }, []);

  const save = async () => {
    try {
      if (editId) await api.put(`/trucks/${editId}`, form);
      else await api.post("/trucks", form);
      toast.success("Saved"); setOpen(false); load();
    } catch(e){ toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const remove = async (id) => { if(!confirm("Delete truck?")) return; await api.delete(`/trucks/${id}`); load(); };

  return (
    <div className="p-8" data-testid="trucks-page">
      <div className="flex items-start justify-between mb-6">
        <div><h1 className="font-display text-3xl text-slate-900">Trucks</h1><p className="text-slate-500 text-sm">Vehicle master</p></div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button className="btn-primary" onClick={()=>{setForm(empty); setEditId(null);}} data-testid="new-truck-btn"><Plus size={16}/> New Truck</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>{editId?"Edit Truck":"New Truck"}</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div><Label>Number</Label><Input value={form.number} onChange={(e)=>setForm({...form, number: e.target.value})} placeholder="WB 25 A 1234" data-testid="truck-number-input"/></div>
              <div className="grid grid-cols-2 gap-3">
                <div><Label>Owner Name</Label><Input value={form.owner_name} onChange={(e)=>setForm({...form, owner_name: e.target.value})}/></div>
                <div><Label>Owner Phone</Label><Input value={form.owner_phone} onChange={(e)=>setForm({...form, owner_phone: e.target.value})}/></div>
              </div>
              <div><Label>Capacity</Label><Input value={form.capacity} onChange={(e)=>setForm({...form, capacity: e.target.value})} placeholder="e.g. 9 tonne"/></div>
            </div>
            <DialogFooter><Button onClick={save} className="btn-primary" data-testid="save-truck-btn">Save</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>

      <div className="bg-white border border-slate-100 rounded-xl">
        <div className="overflow-x-auto"><table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-600"><tr>
            <th className="text-left px-4 py-2">Number</th>
            <th className="text-left px-4 py-2">Owner</th>
            <th className="text-left px-4 py-2">Owner Phone</th>
            <th className="text-left px-4 py-2">Capacity</th>
            <th className="text-right px-4 py-2">Actions</th>
          </tr></thead>
          <tbody>
            {items.length===0 && <tr><td colSpan={5} className="px-4 py-10 text-center text-slate-400">No trucks yet.</td></tr>}
            {items.map(t=>(
              <tr key={t.id} className="border-t border-slate-100">
                <td className="px-4 py-2 font-mono">{t.number}</td>
                <td className="px-4 py-2">{t.owner_name}</td>
                <td className="px-4 py-2">{t.owner_phone}</td>
                <td className="px-4 py-2">{t.capacity}</td>
                <td className="px-4 py-2 text-right">
                  <button onClick={()=>{ setForm({number:t.number, owner_name:t.owner_name, owner_phone:t.owner_phone, capacity:t.capacity}); setEditId(t.id); setOpen(true); }} className="p-2 hover:bg-slate-100 rounded"><Pencil size={16}/></button>
                  <button onClick={()=>remove(t.id)} className="p-2 hover:bg-red-50 rounded text-red-600"><Trash2 size={16}/></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table></div>
      </div>
    </div>
  );
}
